import { ROOT_FONT_SIZE_PIXELS, SPACING_UNIT_PX } from '../constants';
export var spacing = numberOfUnits => {
  return "".concat(numberOfUnits * SPACING_UNIT_PX / ROOT_FONT_SIZE_PIXELS, "rem");
};
export var SPACING_PRESETS = {
  globalLeftMarginDesktop: spacing(20),
  globalRightMarginDesktop: spacing(20),
  globalLeftMarginMobile: spacing(5),
  globalRightMarginMobile: spacing(5)
};